import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AssetUtil, ConnectionController, EventsController, ThemeController } from '@web3modal/core';
import { customElement } from '@web3modal/ui';
import { html } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { W3mConnectingWidget } from '../../utils/w3m-connecting-widget/index.js';
import styles from './styles.js';
let W3mConnectingWcQrcode = class W3mConnectingWcQrcode extends W3mConnectingWidget {
  constructor() {
    var _this$wallet$name, _this$wallet;
    super();
    this.forceUpdate = () => {
      this.requestUpdate();
    };
    window.addEventListener('resize', this.forceUpdate);
    EventsController.sendEvent({
      type: 'track',
      event: 'SELECT_WALLET',
      properties: {
        name: (_this$wallet$name = (_this$wallet = this.wallet) === null || _this$wallet === void 0 ? void 0 : _this$wallet.name) !== null && _this$wallet$name !== void 0 ? _this$wallet$name : 'WalletConnect',
        platform: 'qrcode'
      }
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('resize', this.forceUpdate);
  }
  render() {
    this.onRenderProxy();
    return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <wui-flex padding=\"xl\" flexDirection=\"column\" gap=\"xl\" alignItems=\"center\">\n        <wui-shimmer borderRadius=\"l\" width=\"100%\"> ", " </wui-shimmer>\n\n        <wui-text variant=\"paragraph-500\" color=\"fg-100\">\n          Scan this QR Code with your phone\n        </wui-text>\n        ", "\n      </wui-flex>\n\n      <w3m-mobile-download-links .wallet=", "></w3m-mobile-download-links>\n    "])), this.qrCodeTemplate(), this.copyTemplate(), this.wallet);
  }
  onRenderProxy() {
    if (!this.ready && this.uri) {
      this.timeout = setTimeout(() => {
        this.ready = true;
      }, 200);
    }
  }
  qrCodeTemplate() {
    if (!this.uri || !this.ready) {
      return null;
    }
    const size = this.getBoundingClientRect().width - 40;
    const alt = this.wallet ? this.wallet.name : undefined;
    ConnectionController.setWcLinking(undefined);
    ConnectionController.setRecentWallet(this.wallet);
    return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([" <wui-qr-code\n      size=", "\n      theme=", "\n      uri=", "\n      imageSrc=", "\n      alt=", "\n    ></wui-qr-code>"])), size, ThemeController.state.themeMode, this.uri, ifDefined(AssetUtil.getWalletImage(this.wallet)), ifDefined(alt));
  }
  copyTemplate() {
    const inactive = !this.uri || !this.ready;
    return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<wui-link\n      .disabled=", "\n      @click=", "\n      color=\"fg-200\"\n      data-testid=\"copy-wc2-uri\"\n    >\n      <wui-icon size=\"xs\" color=\"fg-200\" slot=\"iconLeft\" name=\"copy\"></wui-icon>\n      Copy link\n    </wui-link>"])), inactive, this.onCopyUri);
  }
};
W3mConnectingWcQrcode.styles = styles;
W3mConnectingWcQrcode = __decorate([customElement('w3m-connecting-wc-qrcode')], W3mConnectingWcQrcode);
export { W3mConnectingWcQrcode };
//# sourceMappingURL=index.js.map